<template>

    <v-select :model="val" @input="val = $event">
        <option v-for="r in ratings" :key="r.score" :value="r.score">
            <span>{{ '★'.repeat(r.score) }} {{ r.label }}</span>
        </option>
    </v-select>

</template>

<script>

export default {

    props: {
        model: {
            required: true,
        },
    },

    data() {
        return {
            val: this.model !== null && this.model !== undefined ? this.model : '',
            ratings: [],
        }
    },

    created() {
        this.ratings = this.project.ratings.sort(function(a, b) {
            return b.score - a.score;
        });
    },

    watch: {

        model(val) {
            this.val = val;
        },

        val(val) {
            this.$emit('input', val);
        },

    },

}

</script>
